import React from 'react';

export function Counter({ total }: { total: string | number }) {
  return (
    <span className="text-neutral-800 text-sm font-semibold rounded-md desktop:ml-0 ml-auto flex items-center justify-center min-w-[25px] h-[25px] bg-[rgba(0,0,0,.05)]">
      {total}
    </span>
  );
}
